import React from 'react';

const Loader = () => (
  <div className='flex items-center justify-center min-h-[200px] w-full'>
    <span className='loader-spinner' aria-label='Cargando...' />
  </div>
);

export default Loader;
